var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"goods-item"},[_c('img',{staticClass:"goods-img",attrs:{"src":_vm.cover,"alt":"商品"}}),_c('div',{staticClass:"goods-info"},[_c('img',{staticClass:"goods-coin",attrs:{"src":require("../images/coin.png"),"alt":"金币"}}),_vm._v(" "+_vm._s(_vm.price)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }